// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Diamond40FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Diamond40Filled: FC<Diamond40FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="m7.347 10.084-3.18-3.125 1.986-2 3.152 3.18-1.958 1.945Zm11.32-3.278V2.333h2.778v4.473h-2.778Zm13.986 3.278-1.958-1.959 3.18-3.18 1.958 2.013-3.18 3.126ZM20.055 35.666l-13.708-13.5h27.417l-13.709 13.5ZM13.333 10.86H26.75l7.028 8.528H6.333l7-8.528Z" />
        </svg>
    );
};

export default Diamond40Filled;
